// src/components/HeroSlider.jsx
import React, { useState, useEffect } from 'react';
import './HeroSlider.css';
import slide1 from '../assets/slider1.jpg';
import slide2 from '../assets/slider2.jpg';
import slide3 from '../assets/slider3.jpg';
import slide4 from '../assets/slider4.jpg';
import slide5 from '../assets/slider5.jpg';
import slide6 from '../assets/slider6.jpg';
import slide7 from '../assets/slider7.jpg';


import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const slides = [
  { id: 1, title: 'Yeldeğirmeni’nde her çocuk bir dönüşüm başlatır.!', subtitle: '', img: slide1 },
  { id: 5, title: 'Alternatif bir eğitim: düşünen, sorgulayan, üreten öğrenciler', subtitle: '', img: slide5 },
  { id: 3, title: 'Alternatif bir eğitim: düşünen, sorgulayan, üreten öğrenciler', subtitle: '', img: slide3 },
  { id: 6, img: slide6 },
  { id: 7, img: slide7 },
  { id: 2, title: 'Doğa ile iç içe, yaşayarak öğrenme', subtitle: '', img: slide2 },
  { id: 4, img: slide4 },



];

export default function HeroSlider() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const iv = setInterval(() => {
      setIndex(i => (i + 1) % slides.length);
    }, 8000);
    return () => clearInterval(iv);
  }, []);

  const prev = () => setIndex(i => (i - 1 + slides.length) % slides.length);
  const next = () => setIndex(i => (i + 1) % slides.length);

  const slideCount = slides.length;
  const translatePercent = index * (100 / slideCount);

  return (
    <section className="hero-slider">
      <div
        className="slides"
        style={{
          width: `${slideCount * 100}%`,
          transform: `translateX(-${translatePercent}%)`
        }}
      >
        {slides.map(({ id, title, subtitle, img }) => (
          <div
            className="hero"
            key={id}
            style={{ flex: `0 0 ${100 / slideCount}%` }}
          >
            <img className="hero-bg" src={img} alt={title} />
            <div className="overlay" />
            <div className="hero-center">
              
            </div>
          </div>
        ))}
      </div>
      <div className="hero-buttons">
        <button className="arrow left" onClick={prev}>
          <FaChevronLeft />
        </button>
        <button className="arrow right" onClick={next}>
          <FaChevronRight />
        </button>
      </div>
    </section>
  );
}
